import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8C13.0609 8 14.0783 8.42143 14.8284 9.17157C15.5786 9.92172 16 10.9391 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12C8 10.9391 8.42143 9.92172 9.17157 9.17157Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.51201 12C4.74752 15.4964 8.08323 18 12 18C15.9177 18 19.2525 15.4965 20.488 12C19.2525 8.50354 15.9177 6 12 6C8.08323 6 4.74752 8.50359 3.51201 12ZM1.50394 11.7004C2.90509 7.23851 7.07378 4 12 4C16.9273 4 21.0949 7.23856 22.4961 11.7004C22.5573 11.8954 22.5573 12.1046 22.4961 12.2996C21.0949 16.7614 16.9273 20 12 20C7.07378 20 2.90509 16.7615 1.50394 12.2996C1.4427 12.1046 1.4427 11.8954 1.50394 11.7004Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xmlns:svgjs": "http://svgjs.com/svgjs",
  version: "1.1",
  viewBox: "0 0 488.85 488.85",
  "xml:space": "preserve"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("g", null, [
  /*#__PURE__*/_createVNode("g", { xmlns: "http://www.w3.org/2000/svg" }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M244.425,98.725c-93.4,0-178.1,51.1-240.6,134.1c-5.1,6.8-5.1,16.3,0,23.1c62.5,83.1,147.2,134.2,240.6,134.2   s178.1-51.1,240.6-134.1c5.1-6.8,5.1-16.3,0-23.1C422.525,149.825,337.825,98.725,244.425,98.725z M251.125,347.025   c-62,3.9-113.2-47.2-109.3-109.3c3.2-51.2,44.7-92.7,95.9-95.9c62-3.9,113.2,47.2,109.3,109.3   C343.725,302.225,302.225,343.725,251.125,347.025z M248.025,299.625c-33.4,2.1-61-25.4-58.8-58.8c1.7-27.6,24.1-49.9,51.7-51.7   c33.4-2.1,61,25.4,58.8,58.8C297.925,275.625,275.525,297.925,248.025,299.625z",
      fill: "currentColor"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.fill)
    ? (_openBlock(), _createBlock("svg", _hoisted_1, [
        _hoisted_2,
        _hoisted_3
      ]))
    : (_openBlock(), _createBlock("svg", _hoisted_4, [
        _hoisted_5
      ]))
}